import React from 'react';
import { ask__ } from './../../shared/utils/i18n.js';
import { getWebsiteBaseUrl } from './../../shared/utils/environment.js';

import './Logout.scss';

export default function Logout() {

  const logoutUrl = getWebsiteBaseUrl() + '/auth-logout&return=' + window.top.location.href + '#orton-booking';

  return (
    <div className="logout">

      <h2>{ask__('Logout: Title')}</h2>
      <p>{ask__('Logout: Description')}</p>
      <div className="logout__button">
        <a target="_parent" href={logoutUrl}>{ask__('Logout: Button')}</a>
      </div>


    </div>
  )

}
